var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcToolLetra(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1123",
    "data-name": "Grupo 1123",
    transform: "translate(-0.367 -0.367)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1121",
    "data-name": "Grupo 1121",
    transform: "translate(0.407 0.407)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1120",
    "data-name": "Grupo 1120",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1119",
    "data-name": "Grupo 1119"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1118",
    "data-name": "Grupo 1118"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1117",
    "data-name": "Grupo 1117"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_244",
    "data-name": "Rect\\xE1ngulo 244",
    width: 17,
    height: 17,
    transform: "translate(-0.04 -0.04)",
    fill: "#684e07"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1122",
    "data-name": "Grupo 1122",
    transform: "translate(1.68 1.682)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_598",
    "data-name": "Trazado 598",
    d: "M5.535,16.64h5.22V15.329H8.817V3.576h3.9V5.523h1.3V2.27H2.267V5.522H3.575V3.578H7.483V15.34H5.535Zm6.211-1.961H15V13.373h-.957V8.161h1.293v.96h1.3V6.844H10.109V9.121h1.307V8.16h1.29v5.218h-.96Z",
    transform: "translate(-2.267 -2.27)",
    fill: "#684e07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_599",
    "data-name": "Trazado 599",
    d: "M5.535,16.64v-1.3H7.483V3.578H3.575V5.522H2.267V2.27H14.018V5.523h-1.3V3.576h-3.9V15.329h1.938V16.64Z",
    transform: "translate(-2.267 -2.27)",
    fill: "#684e07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_600",
    "data-name": "Trazado 600",
    d: "M15.069,16.617v-1.3h.96V10.1h-1.29v.961H13.432V8.782h6.533v2.277h-1.3V10.1H17.371v5.212h.957v1.306Z",
    transform: "translate(-5.59 -4.208)",
    fill: "#684e07"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcToolLetra);
export default __webpack_public_path__ + "static/media/ic_tool_letra.0cbd5242afe35678235643b30db895f2.svg";
export { ForwardRef as ReactComponent };